<template>
  <Transition name="fade" appear="">
      <div class="pet-card bg-lightblue">
      <div class="pet-card__favorite-icon-wrap">
        <i
          class="material-icons pet-card__favorite-icon"
          :class="{ active: petStore.isFav(pet.id) }"
          @click.stop="petStore.handleFavoriteClick(pet.id)"
          >favorite</i
        >
      </div>

      <div
        v-if="petStore.petThumbById(pet.id)"
        class="pet-card__image"
        :style="{
          'background-image': 'url(' + petStore.petThumbById(pet.id) + ')',
        }"
      ></div>
      
      <div
        v-if="!petStore.petThumbById(pet.id)"
        class="pet-card__image pet-card__image--empty"
      ></div>

      <div class="pet-card__content">
        <div class="pet-card__textbox">
          <h3 class="pet-card__title">{{ pet.attributes.name }}</h3>
          <p class="pet-card__subtitle">{{ pet.attributes.breedPrimary }}</p>
        </div>

        <div class="pet-card__tags">
          <span class="pet-card__tag bg-white">
            {{ petStore.petOrgById(pet.id).city }},
            {{ petStore.petOrgById(pet.id).state }}
          </span>
          <!-- <span class="pet-card__tag bg-lightgreen">
                  {{ pet.attributes.ageGroup }} {{ pet.attributes.sex }}
                </span> -->
        </div>
      </div>
    </div>
  </Transition>


</template>

<script>
import { usePetStore } from "../stores/PetStore";
export default {
  // register prop that was passed in to the component
  props: ["pet"],
  setup() {
    const petStore = usePetStore();
    return { petStore };
  },
};
</script>

<style lang="scss" scoped>
@import "scss/global/variables.scss";
@import "scss/global/mixins.scss";
@import "scss/global/breakpoints.scss";
@import "scss/global/layout.scss";
@import "scss/global/colors.scss";

.pet-card {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  margin-bottom: 0 !important;
  cursor: pointer;
  width: 100%;
  margin-bottom: 10px;
  padding: 0px;
  position: relative;
  border: 1px solid #d9d9d9;
  border-radius: 10px;
  box-shadow: 0px 0px 12px 0px #0000001a;
  overflow: hidden;
  &__favorite-icon-wrap {
    position: absolute;
    z-index: 11;
    top: 12px;
    right: 12px;
    line-height: 0;
    background-color: rgba(255, 255, 255, 0.75);
    border-radius: 50%;
    padding: 4px;

    i {
      font-size: rem(20);
      color: #7e7e7e;
      cursor: pointer;
      &.active {
        color: red;
      }
      @include desktop {
        font-size: rem(24);
      }
    }
  }
  &__image {
    width: 100%;
    height: 200px;
    background-size: cover;
    background-position: top center;
    background-repeat: no-repeat;
    @include tablet {
      height: 250px;
    }
    @include desktop {
      height: 300px;
    }
  }
  &__image--empty {
    width: 100%;
    background-size: 70%;
    background-position: center;
    background-repeat: no-repeat;
    border-bottom: 1px solid #bbb;
    background-color: #fff;
    background-image: url('/src/assets/paw-transparent.png');
  }
  &__content {
    flex: 1 0 auto;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    padding-top: 10px;
    text-align: center;
    @include desktop {
      //padding: 15px 10px;
      padding: 2px 15px 10px; //Steve 
    }
  }
  &__title {
    font-size: 2rem;
    font-weight: bold;
    @include desktop {
      font-size: 1.5rem;
    }
  }
  &__subtitle {
    margin-bottom: 0.5em;
    font-size: rem(13);
    @include desktop {
      font-size: 1rem;
    }
  }
  &__tags {
    @include device-only {
      padding: 0 10px 10px;
    }
    @include desktop {
      @include flex-center;
    }
  }
  &__tag {
    display: block;
    padding: 5px 10px;
    margin-bottom: 5px;
    font-size: 1.3rem;
    white-space: nowrap;
    border: 1px solid#d5d5d5;
    border-radius: 5px;
    // border: 1px solid #978c83;
    // box-shadow: 0px 0.5px 6px 2px rgb(2 3 3 / 6%);
    &:last-child {
      margin-bottom: 0;
    }
    @include desktop {
      display: inline-block;
      width: auto;
      margin: 0 3px;
      font-size: rem(13);
    }
  }
}

    .fade-enter-active,
    .fade-leave-active {
      transition: opacity 0.5s ease;
    }

    .fade-enter-from,
    .fade-leave-to {
      opacity: 0;
    }
</style>
